import {
  useLoginMutation,
  useMeQuery,
  useResetPasswordMutation
} from 'app/features/auth/api';
import { authSelector } from 'app/features/auth/slice';
import { RootState } from 'app/store';
import React from 'react';
import { useSelector } from 'react-redux';

const AuthContext = React.createContext<
  Partial<
    {
      token: string;
      login: ReturnType<typeof useLoginMutation>[0];
      loginResult: ReturnType<typeof useLoginMutation>[1];
      resetPassword: ReturnType<typeof useResetPasswordMutation>[0];
      resetPasswordResult: ReturnType<typeof useResetPasswordMutation>[1];
    } & RootState['auth']
  >
>({} as any);

const AuthProvider = ({ children }: any) => {
  const authState = useSelector(authSelector);
  const [login, loginResult] = useLoginMutation();
  const [resetPassword, resetPasswordResult] = useResetPasswordMutation();
  const { refetch } = useMeQuery({});
  const currentToken = React.useMemo(() => {
    return authState.token;
  }, [authState]);

  React.useEffect(() => {
    if (currentToken) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentToken]);
  return (
    <AuthContext.Provider
      value={{
        login,
        loginResult,
        resetPassword,
        resetPasswordResult,
        token: currentToken,
        ...authState,
        // hack login
        // isAuthorized: true,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
